<script lang="ts">
  import { auth, googleProvider } from '../Firebase'
  import { signInWithPopup } from 'firebase/auth'
  import CtaButton from '../Generic/CtaButton.svelte'

  function login() {
    void signInWithPopup(auth, googleProvider)
  }
</script>

<CtaButton on:click={login}>Sign In with Google</CtaButton>
